import * as React from 'react'
import styled from 'styled-components'
import I18n from '../../../core/i18n'
import { userService } from '../../../core/services'
import { Panel, Pagination, AvatarImage } from '../../atoms'
import { utilService } from '../../../core/services'
import * as interfaces from '../../../static/interfaces'
import ListBlock from 'components/atoms/ListBlock'
import Typography from 'components/atoms/_layouts/Typography'
import TextClamp from 'components/atoms/TextClamp'
import SidebarLayout from '../_layouts/sidebarLayout'

declare var window: interfaces.IWindow

interface IProps {
  notifications: any
  user: any
}

const Index: React.FC<IProps> = props => {
  const {
    notifications: notifications,
    pagination: pagination,
  } = userService.getNotificationsFromJson(props.notifications.notifications)
  const onChangePageHandler = page => {
    const params = new URLSearchParams(window.location.search)
    params.set('page', page)

    location.href = `${location.pathname}?${params.toString()}`
  }
  const { data: user } = utilService.getDataFromJson(props.user)

  return (
    <SidebarLayout user={user}>
      <Wrapper>
        <Panel title={I18n.t('generic.notification')} noDecoration={user.guest ? true : false}>
          {notifications.map(notification => (
            <ListBlock key={notification.id}>
              <div
                className="Notification_Content"
                onClick={() => (location.href = notification.url)}
              >
                <AvatarImage
                  avatarURL={
                    notification.owner?.admin
                      ? '/images/custom/logo_mail.png'
                      : notification.owner?.avatar_url
                  }
                  size={60}
                />
                <div>
                  <Typography type="subtitle" size="xl">
                    <TextClamp line={2}>{notification.title}</TextClamp>
                  </Typography>
                  <Typography type="body" size="sm" color="subtext">
                    {notification.created_at}
                  </Typography>
                </div>
              </div>
            </ListBlock>
          ))}
          {pagination && (
            <Pagination
              onChangePageHandler={onChangePageHandler}
              currentPage={pagination.current_page}
              prevPage={pagination.prev_page}
              nextPage={pagination.next_page}
              totalCount={pagination.total_count}
              totalPages={pagination.total_pages}
            />
          )}
        </Panel>
      </Wrapper>
    </SidebarLayout>
  )
}

const Wrapper = styled.div`
  .Notification_Content {
    display: flex;
    align-items: center;
    justify-content: flex-start;
    gap: 16px;
    cursor: pointer;
  }
`
export default Index
